import { getAuth } from "firebase/auth";
import { getAuthCentral } from "../../config/FirebaseConfig";
import { getFirestore, doc, getDoc } from "firebase/firestore";
import { checkDB } from "../../models/DataFunctions.js";
import addLogDocument from "../addLogDocument"; // Assuming a custom log function

const transferInvoiceOutsideSigned = async (
  invoiceid,
  dropzone_files,
  token,
  prefix
) => {
  // Define the endpoint URL
  let url = prefix + `devis/${invoiceid}/transfer-outside-signed`;

  // Define the request body
  const body = {
    dropzone_files: dropzone_files,
  };

  // Define headers
  const headers = {
    "Content-Type": "application/json",
    Authorization: `Bearer ${token}`,
  };

  try {
    // Make the POST request
    const response = await fetch(url, {
      method: "POST",
      headers: headers,
      body: JSON.stringify(body), // Encode the body as JSON
    });

    // Check for user authentication using Firebase
    const auth = getAuthCentral();
    const currentUser = auth.currentUser;

    if (!currentUser) {
      return "User not logged in";
    }

    // Access Firestore and get user details
    const db = getFirestore();
    const userRef = doc(db, "user", currentUser.uid);
    const userSnapshot = await getDoc(checkDB(userRef));

    if (!userSnapshot.exists()) {
      return "User document not found";
    }

    const org_id = userSnapshot.get("org_id");

    // Log the request and response
    await addLogDocument(
      url,
      prefix,
      userRef,
      org_id,
      response.status.toString(),
      "",

      "",
      JSON.stringify(body), // Logs the request body as string
      await response.text() // Logs the response body as string
    );

    // Check if the request was successful
    if (response.ok) {
      return "Document validated successfully";
    } else {
      console.error(`Failed to validate document: ${response.status}`);
      return `Failed to validate document: ${response.status}`;
    }
  } catch (error) {
    // Handle any error that occurs during the fetch process
    console.error(`Exception occurred: ${error.message}`);
    return `Exception: ${error.message}`;
  }
};

export default transferInvoiceOutsideSigned;
